import { composeWrappers } from "@redotech/react-util/component";
import { memo } from "react";
import { Outlet } from "react-router-dom";
import { ScanningContextProvider } from "./scanning-context/context";

export const ScanRoot = memo(function ScanRoot() {
  return composeWrappers((inner) => (
    <ScanningContextProvider>{inner}</ScanningContextProvider>
  ))(<Outlet />);
});
